import React, { useRef, useState, useEffect } from "react";
import { FormHelperText, Backdrop, CircularProgress, InputAdornment, Chip, Avatar, CardContent, Typography, Stack, CardMedia, Select, MenuItem, Divider, Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, IconButton, FormLabel, Checkbox, Card, Button, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Radio, RadioGroup, TextField, FormControl } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import DataObjectIcon from "@mui/icons-material/DataObject";
import InfoIcon from "@mui/material/SvgIcon";
import ApiRequest from "../ApiRequest";
import Grid from "@mui/material/Grid";
import useStore from "../Store";
import { useAlert } from "../AlertProvider";
import { templateBase, buttonBase, templateItemHighlightBase, templateItemBase, templateItemListBase, templateRepresentLinkBase, mmsBase } from "../jsonTemplate.js";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { StyledCarousel } from "../StyledMui";

const NewTemplateDialog = () => {
  const { BASIC_ALERT_DURATION, isCloneMode, isTemplateEditMode, templateForEditMode, isTemplateReadOnlyMode, getTemplates, setImageModalSubtype, channels, setSelectedSingleImageData, selectedSingleImageData, newTemplateDialog, closeNewTemplateDialog, getImages, images, openModal, setImageModalSelectMode, setImageModalType, setDisableImageModalType } = useStore((state) => state.header);
  const [messageType, setMessageType] = useState("BA");
  const [emphasisType, setEmphasisType] = useState("NONE");
  const [templateContent, setTemplateContent] = useState("");
  const [carouselFeeds, setCarouselFeeds] = useState([{ header: "", content: "" }]);
  const [securityTemplate, setSecurityTemplate] = useState(false);
  const [representativeLink, setRepresentativeLink] = useState(false);
  const [buttons, setButtons] = useState(messageType === "FC" ? [[], []] : [[]]);
  const [quickLinks, setQuickLinks] = useState([]);
  const [messageTemplateType, setMessageTemplateType] = useState("alimtalk");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [templateCode, setTemplateCode] = useState("");
  const [templateName, setTemplateName] = useState("");
  const { showAlert } = useAlert();
  const [failbackContent, setFailbackContent] = useState("");
  const [failbackContentTitle, setFailbackContentTitle] = useState("");
  const [itemListHeader, setItemListHeader] = useState("");
  const [itemListTitle1, setItemListTitle1] = useState("");
  const [itemListTitle2, setItemListTitle2] = useState("");
  const [itemListTitle3, setItemListTitle3] = useState("");
  const [itemListTitle4, setItemListTitle4] = useState("");
  const [itemListTitle1Url, setItemListTitle1Url] = useState("");
  const [itemListTitle2Url, setItemListTitle2Url] = useState("");
  const [itemListTitle3Url, setItemListTitle3Url] = useState("");
  const [itemListTitle4Url, setItemListTitle4Url] = useState("");
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [loadingModal, setLoadingModal] = useState(false);
  const [selectedText, setSelectedText] = useState({ text: "", field: null });

  const initialErrorState = {
    selectedChannel: false,
    templateCode: false,
    templateName: false,
    additionalInfo: false,
    itemListHeader: false,
    itemListTitle1: false,
    itemListTitle2: false,
    itemListTitle3: false,
    itemListTitle4: false,
    title: false,
    subtitle: false,
  };

  const [errorCheck, setErrorCheck] = useState(initialErrorState);

  const getMaxLength = () => {
    switch (messageType) {
      case "image":
        return 400;
      case "wide":
        return 76;
      case "MI" || "AD":
        return 964;
      case "FC":
        return { header: 20, content: 180 };
      default:
        return 1000;
    }
  };

  useEffect(() => {
    if (!isTemplateReadOnlyMode && !isTemplateEditMode && !isCloneMode) {
      let newButtons;
      if (messageType === "AD" || messageType === "MI") {
        if (buttons.length === 0 || buttons[0].find((button) => button.linkType === "AC") === undefined) {
          newButtons = [[{ name: "채널추가", linkType: "AC", ordering: 1, readOnly: true }], ...buttons];
        } else {
          newButtons = buttons;
        }
      } else {
        if (buttons.length > 0 && buttons[0].find((button) => button.linkType === "AC") !== undefined) {
          newButtons = buttons.map((buttonSet) => buttonSet.filter((button) => button.linkType !== "AC"));
        } else {
          if (buttons.length > 0 && buttons[0].length > 0 && buttons[0][0].type !== "AC") {
            newButtons = [...buttons];
            newButtons[0][0] = { ...newButtons[0][0], linkType: "NONE" };
          } else {
            newButtons = buttons;
          }
        }
      }
      setButtons(newButtons);
      setSelectedSingleImageData();
    }
  }, [messageType]);

  //수정 시 초기값 세팅
  useEffect(() => {
    setErrorCheck(initialErrorState);
    if (isCloneMode) {
      setTemplateCode("");
      setTemplateName("");
    } else {
      setTemplateCode(templateForEditMode.templateCode || "");
      setTemplateName(templateForEditMode.templateName || "");
    }
    setSelectedChannel(channels.find((channel) => channel.channelName === templateForEditMode.channelName) || "" || "");
    setMessageType(templateForEditMode.templateMessageType || "BA");
    setEmphasisType(templateForEditMode.templateEmphasizeType || "NONE");
    setTemplateContent(templateForEditMode.templateContent || "");
    if (templateForEditMode.templateMessageType === "FC") {
      setCarouselFeeds(
        [
          { header: templateForEditMode.carouselHeader1, content: templateForEditMode.carouselMessage1 },
          { header: templateForEditMode.carouselHeader2, content: templateForEditMode.carouselMessage2 },
          { header: templateForEditMode.carouselHeader3, content: templateForEditMode.carouselMessage3 },
          { header: templateForEditMode.carouselHeader4, content: templateForEditMode.carouselMessage4 },
          { header: templateForEditMode.carouselHeader5, content: templateForEditMode.carouselMessage5 },
          { header: templateForEditMode.carouselHeader6, content: templateForEditMode.carouselMessage6 },
        ].filter((item) => item.header && item.content)
      );
    } else {
      setCarouselFeeds([{ header: "", content: "" }]);
    }
    setSecurityTemplate(templateForEditMode.securityTemplate || false);
    setRepresentativeLink(templateForEditMode.representativeLink || false);
    setButtons(templateForEditMode.buttons ? JSON.parse(templateForEditMode.buttons) : messageType === "FC" ? [[], []] : [[]]);
    setQuickLinks(templateForEditMode.quickReplies ? JSON.parse(templateForEditMode.quickReplies) : []);
    setMessageTemplateType(templateForEditMode.templateType || "alimtalk");
    setAdditionalInfo(templateForEditMode.templateExtra || "");
    setTitle(templateForEditMode.templateTitle || "");
    setSubtitle(templateForEditMode.templateSubtitle || "");

    setItemListHeader(templateForEditMode.itemListHeader || "");
    setItemListTitle1(templateForEditMode.itemListTitle1 || "");
    setItemListTitle2(templateForEditMode.itemListTitle2 || "");
    setItemListTitle3(templateForEditMode.itemListTitle3 || "");
    setItemListTitle4(templateForEditMode.itemListTitle4 || "");
    setItemListTitle1Url(templateForEditMode.itemListTitle1Url || "");
    setItemListTitle2Url(templateForEditMode.itemListTitle2Url || "");
    setItemListTitle3Url(templateForEditMode.itemListTitle3Url || "");
    setItemListTitle4Url(templateForEditMode.itemListTitle4Url || "");

    setSelectedSingleImageData({ imageUrl: templateForEditMode?.templateImageUrl, name: templateForEditMode?.templateImageName });
    setFailbackContent(templateForEditMode.mmsAttach ? JSON.parse(templateForEditMode.mmsAttach).mmsContent : "");
    setFailbackContentTitle(templateForEditMode.mmsAttach ? JSON.parse(templateForEditMode.mmsAttach).subject : "");
  }, [isCloneMode, isTemplateReadOnlyMode, templateForEditMode]);

  const handleMessageTypeChange = (event) => {
    setMessageType(event.target.value);
    if (event.target.value === "wide" && buttons[0].length >= 1) {
      showAlert("와이드형 메세지는 버튼 하나만 사용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
      setButtons([buttons[0].slice(0, 1)]);
    } else if (event.target.value === "FL" && buttons[0].length >= 2) {
      showAlert("와이드 리스트형 메세지는 버튼을 최대 2개 사용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
      setButtons([buttons[0].slice(0, 2)]);
    }
    setCarouselFeeds([{ header: "", content: "" }]);
  };

  const handleTemplateContentChange = (event) => {
    setTemplateContent(event.target.value);
  };

  const handleCarouselFeedChange = (index, field, value) => {
    const newCarouselFeeds = [...carouselFeeds];
    newCarouselFeeds[index][field] = value;
    setCarouselFeeds(newCarouselFeeds);
  };

  const handleAddCarouselFeed = () => {
    if (carouselFeeds.length < 6) {
      setCarouselFeeds((prevCarouselFeeds) => [...prevCarouselFeeds, { header: "", content: "" }]);
    }
  };

  const handleRemoveCarouselFeed = (index) => {
    if (carouselFeeds.length > 2) {
      const newCarouselFeeds = [...carouselFeeds];
      newCarouselFeeds.splice(index, 1);
      setCarouselFeeds(newCarouselFeeds);
    }
  };

  const handlefailbackContentChange = (event) => {
    const value = event.target.value;
    setFailbackContent(value);
  };

  const handlefailbackContentTitleChange = (event) => {
    const value = event.target.value;
    setFailbackContentTitle(value);
  };

  const handleEmphasisTypeChange = (event) => {
    setEmphasisType(event.target.value);
  };

  const handleSecurityTemplateChange = (event) => {
    setSecurityTemplate(event.target.checked);
  };

  const handleMessageTemplateTypeChange = (event) => {
    setMessageTemplateType(event.target.value);
    if (event.target.value === "alimtalk") {
      setMessageType("BA");
      setEmphasisType("NONE");
    } else {
      setMessageType("text");
      setEmphasisType("NONE");
    }
    setQuickLinks([]);
    setButtons([[]]);
    setCarouselFeeds([{ header: "", content: "" }]);
  };

  const handleAddButton = (index) => {
    setButtons((prevButtons) => {
      let updatedButtons = [...prevButtons];
      let currentButtons = updatedButtons[index] || [];

      if (quickLinks?.length > 0 && currentButtons.length >= 2) {
        showAlert("퀵링크 버튼을 사용하는 경우 버튼은 최대 2개까지 사용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
        setButtons([buttons[0].slice(0, 2)]);
      } else if (currentButtons.length >= 5) {
        showAlert("버튼은 최대 5개 까지 활용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
      } else if (messageType === "wide" && currentButtons.length >= 1) {
        showAlert("와이드형 메세지는 버튼 하나만 사용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
      } else if ((messageType === "FL" || messageType === "FC") && currentButtons.length >= 2) {
        showAlert("와이드 리스트형 메세지는 버튼을 최대 2개 사용할 수 있습니다.", "error", BASIC_ALERT_DURATION);
      } else {
        currentButtons.push({ ordering: currentButtons.length + 1, linkType: "NONE", name: "", linkMo: "", linkPc: "", linkAnd: "", linkIos: "" });
      }

      updatedButtons[index] = currentButtons;
      return updatedButtons;
    });
  };

  const handleAddQuickLink = () => {
    if (buttons[0].length > 2) {
      setButtons([buttons[0].slice(0, 2)]);
      showAlert("퀵링크 버튼 사용 시 버튼은 최대 2개까지 사용할 수 있습니다. 2개를 초과하여 입력한 버튼은 자동으로 삭제됩니다.", "info", BASIC_ALERT_DURATION);
    }

    if (quickLinks?.length >= 10) {
      showAlert("퀵링크 버튼은 최대 10개까지만 생성할 수 있습니다.", "error", BASIC_ALERT_DURATION);
    } else {
      setQuickLinks([...quickLinks, { ordering: quickLinks?.length + 1, linkType: "NONE", name: "", linkMo: "", linkPc: "", linkAnd: "", linkIos: "" }]);
    }
  };

  const handleRemoveButton = (templateIndex, buttonIndex) => {
    setButtons((prevButtons) => {
      return prevButtons.map((templateButtons, i) => {
        if (i !== templateIndex) {
          return templateButtons;
        }
        //버튼제거
        const updatedTemplateButtons = templateButtons.filter((_, j) => j !== buttonIndex);
        //순서재정렬
        const reorderedTemplateButtons = updatedTemplateButtons.map((button, index) => {
          return { ...button, ordering: index + 1 };
        });
        return reorderedTemplateButtons;
      });
    });
  };

  const handleRemoveQuickLink = (index) => {
    setQuickLinks((prevQuickLinks) => {
      // QuickLink제거
      const updatedQuickLinks = prevQuickLinks.filter((_, i) => i !== index);

      // 순서재정렬
      const reorderedQuickLinks = updatedQuickLinks.map((link, index) => {
        return { ...link, ordering: index + 1 };
      });

      return reorderedQuickLinks;
    });
  };

  const handleButtonTypeChange = (templateIndex, buttonIndex, event) => {
    setButtons((prevButtons) => {
      return prevButtons.map((templateButtons, i) => {
        if (i !== templateIndex) {
          return templateButtons;
        }

        const updatedTemplateButtons = templateButtons.map((button, j) => {
          if (j !== buttonIndex) {
            return button;
          }

          return { ...button, linkType: event.target.value };
        });

        return updatedTemplateButtons;
      });
    });
  };

  const handleQuickLinkTypeChange = (event, index) => {
    const newQuickLinks = [...quickLinks];
    newQuickLinks[index].linkType = event.target.value;
    setQuickLinks(newQuickLinks);
  };

  const handleButtonNameChange = (templateIndex, buttonIndex, event) => {
    setButtons((prevButtons) => {
      return prevButtons.map((templateButtons, i) => {
        if (i !== templateIndex) {
          return templateButtons;
        }

        const updatedTemplateButtons = templateButtons.map((button, j) => {
          if (j !== buttonIndex) {
            return button;
          }

          return { ...button, name: event.target.value };
        });

        return updatedTemplateButtons;
      });
    });
  };

  const handleQuickLinkNameChange = (index, event) => {
    const newQuickLinks = [...quickLinks];
    newQuickLinks[index].name = event.target.value;
    setQuickLinks(newQuickLinks);
  };

  const handleButtonLinkChange = (templateIndex, buttonIndex, linkType, value) => {
    setButtons((prevButtons) => {
      return prevButtons.map((templateButtons, i) => {
        if (i !== templateIndex) {
          return templateButtons;
        }

        const updatedTemplateButtons = templateButtons.map((button, j) => {
          if (j !== buttonIndex) {
            return button;
          }

          return { ...button, [linkType]: value };
        });

        return updatedTemplateButtons;
      });
    });
  };

  const handleQuickLinkLinkChange = (quickLink, index, linkType, value) => {
    const newQuickLinks = [...quickLinks];
    newQuickLinks[index][linkType] = value;
    setQuickLinks(newQuickLinks);
  };

  const handleVariableButton = () => {
    const selectedText = window.getSelection().toString();

    if (selectedText) {
      const replacedContent = templateContent.replace(selectedText, `#{${selectedText}}`);
      if (replacedContent.length > getMaxLength()) {
        showAlert("허용 글자 수를 초과하여 입력하였습니다.", "error", BASIC_ALERT_DURATION);
      } else {
        setTemplateContent(replacedContent);
      }
    } else {
      const cursorPosition = templateContent.length;
      const newContent = templateContent.slice(0, cursorPosition) + "#{변수입력}" + templateContent.slice(cursorPosition);
      if (newContent.length > getMaxLength()) {
        showAlert("허용 글자 수를 초과하여 입력하였습니다.", "error", BASIC_ALERT_DURATION);
      } else {
        setTemplateContent(newContent);
      }
    }
  };

  const handleButtonLinkVariableButton = () => {
    console.log(selectedText);
    if (!selectedText.text) return;

    setButtons((prevButtons) =>
      prevButtons.map((buttonGroup, groupIndex) => {
        if (groupIndex !== selectedText.groupIndex) return buttonGroup; // 선택된 버튼 그룹이 아니면 그대로 반환

        return buttonGroup.map((button, buttonIndex) => {
          if (buttonIndex !== selectedText.buttonIndex) return button; // 선택된 버튼이 아니면 그대로 반환

          // 선택된 버튼이면 해당 필드의 텍스트를 변경
          if (selectedText.field === "linkAnd") {
            return { ...button, linkAnd: button.linkAnd.replace(selectedText.text, `#{${selectedText.text}}`) };
          } else if (selectedText.field === "linkIos") {
            return { ...button, linkIos: button.linkIos.replace(selectedText.text, `#{${selectedText.text}}`) };
          } else if (selectedText.field === "linkPc") {
            return { ...button, linkPc: button.linkPc.replace(selectedText.text, `#{${selectedText.text}}`) };
          } else if (selectedText.field === "linkMo") {
            return { ...button, linkMo: button.linkMo.replace(selectedText.text, `#{${selectedText.text}}`) };
          } else {
            return button;
          }
        });
      })
    );
  };

  const handleImageSelect = () => {
    if (emphasisType === "IMAGE") {
      setImageModalSubtype("template");
    } else if (messageType === "image") {
      setImageModalSubtype("default");
    } else if (messageType === "wide") {
      setImageModalSubtype("wide_balloon");
    } else if (messageType === "FL") {
      setImageModalSubtype("wide_item_list");
    } else if (messageType === "FC") {
      setImageModalSubtype("carousel_feed");
    }

    setImageModalType(messageTemplateType);
    setImageModalSelectMode(true);
    setDisableImageModalType(true);
    openModal("imageModal");
    // 이미지 선택 및 업로드 처리
  };

  const handleSelectedChannel = (event) => {
    console.log(event.target.value);
    setSelectedChannel(event.target.value);
  };
  const handleCreateTemplate = async () => {
    if (!selectedChannel || !templateCode || !templateName) {
      setErrorCheck({
        ...initialErrorState,
        selectedChannel: !selectedChannel,
        templateCode: !templateCode,
        templateName: !templateName,
      });
      showAlert("필수 값 입력 후 템플릿을 생성할 수 있습니다.", "error", BASIC_ALERT_DURATION);
    } else if (emphasisType === "TEXT" && (!title || !subtitle)) {
      setErrorCheck({
        ...initialErrorState,
        title: !title,
        subtitle: !subtitle,
      });
      showAlert("강조표기형은 강조표기 문구 입력이 필수입니다.", "error", BASIC_ALERT_DURATION);
    } else if ((messageType === "EX" || messageType === "MI") && !additionalInfo) {
      setErrorCheck({
        ...initialErrorState,
        additionalInfo: !additionalInfo,
      });
      showAlert("부가정보형, 복합형은 부가정보 입력이 필수입니다.", "error", BASIC_ALERT_DURATION);
    } else if (messageType === "FL" && (!itemListHeader || !itemListTitle1 || !itemListTitle2 || !itemListTitle3)) {
      setErrorCheck({
        ...initialErrorState,
        itemListHeader: !itemListHeader,
        itemListTitle1: !itemListTitle1,
        itemListTitle2: !itemListTitle2,
        itemListTitle3: !itemListTitle3,
        itemListTitle4: !itemListTitle4,
      });
      showAlert("아이템 리스트 유형 제목은 최소 3개에서 최대 4개까지 입력하세요.", "error", BASIC_ALERT_DURATION);
    } else if (messageType !== "FL" && messageType !== "FC" && !templateContent) {
      setErrorCheck({
        ...initialErrorState,
        templateContent: !templateContent,
      });
      showAlert("템플릿 내용 입력은 필수입니다.", "error", BASIC_ALERT_DURATION);
    } else if ((emphasisType === "IMAGE" || messageType === "image" || messageType === "wide" || messageType === "FL" || messageType === "FC") && (!selectedSingleImageData || !selectedSingleImageData.imageUrl)) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("메세지에 사용할 이미지를 선택하세요.", "error", BASIC_ALERT_DURATION);
    } else if (buttons.some((buttonArray) => buttonArray.some((button) => button.linkType === "NONE"))) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("버튼의 유형을 선택하세요.", "error", BASIC_ALERT_DURATION);
    } else if (buttons.some((buttonArray) => buttonArray.some((button) => button.name === ""))) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("버튼 이름을 입력하세요.", "error", BASIC_ALERT_DURATION);
    } else if (buttons.some((buttonArray) => buttonArray.some((button) => (button.linkType === "WL" && (!validateUrl(button.linkPc) || !validateUrl(button.linkMo))) || (button.linkType === "AL" && (!validateUrl(button.linkPc) || !validateUrl(button.linkMo) || !validateUrl(button.linkIos) || !validateUrl(button.linkAnd)))))) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("웹링크 또는 앱링크 유형의 버튼에 http:// 또는 https:// 로 시작하는 URL을 입력하세요.", "error", BASIC_ALERT_DURATION);
    } else if (quickLinks.some((quickLink) => quickLink.linkType === "NONE")) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("바로가기의 유형을 선택하세요.", "error", BASIC_ALERT_DURATION);
    } else if (quickLinks.some((quickLink) => quickLink.name === "")) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("바로가기의 이름을 입력하세요.", "error", BASIC_ALERT_DURATION);
    } else if (quickLinks.some((quickLink) => (quickLink.linkType === "WL" && (!validateUrl(quickLink.linkPc) || !validateUrl(quickLink.linkMo))) || (quickLink.linkType === "AL" && (!validateUrl(quickLink.linkPc) || !validateUrl(quickLink.linkMo) || !validateUrl(quickLink.linkIos) || !validateUrl(quickLink.linkAnd))))) {
      setErrorCheck({
        ...initialErrorState,
      });
      showAlert("웹링크 또는 앱링크 유형의 바로가기에 http:// 또는 https:// 로 시작하는 URL을 입력하세요.", "error", BASIC_ALERT_DURATION);
    } else {
      setErrorCheck(initialErrorState);
      setLoadingModal(true);

      templateBase.senderKey = selectedChannel.channelKey;
      templateBase.templateCode = templateCode;

      if (isTemplateEditMode) {
        templateBase.newSenderKey = selectedChannel.channelKey;
        templateBase.newTemplateCode = templateCode;
        templateBase.newTemplateName = templateName;
        templateBase.newTemplateContent = templateContent;
        templateBase.newTemplateMessageType = messageType;
        templateBase.newTemplateEmphasizeType = emphasisType;
        templateBase.newTemplateExtra = additionalInfo;
        templateBase.newTemplateImageName = selectedSingleImageData?.name;
        templateBase.newTemplateImageUrl = selectedSingleImageData?.imageUrl;
        templateBase.newTemplateTitle = title;
        templateBase.newTemplateSubtitle = subtitle;
      } else {
        templateBase.templateName = templateName;
        templateBase.templateContent = templateContent;
        templateBase.templateMessageType = messageType;
        templateBase.templateEmphasizeType = emphasisType;
        templateBase.templateExtra = additionalInfo;
        templateBase.templateImageName = selectedSingleImageData?.name;
        templateBase.templateImageUrl = selectedSingleImageData?.imageUrl;
        templateBase.templateTitle = title;
        templateBase.templateSubtitle = subtitle;
      }
      templateBase.securityFlag = securityTemplate;
      templateBase.buttons = buttons[0];
      templateBase.quickReplies = quickLinks;

      mmsBase.mmsContent = failbackContent;
      mmsBase.callback = selectedChannel.channelPhone;
      mmsBase.subject = failbackContentTitle;

      console.log(templateBase);

      let apiResponse;
      if (messageTemplateType === "alimtalk") {
        let endPoint;
        try {
          if (isTemplateEditMode) {
            endPoint = "/biztalkCenterApi/alimtalk/template/update";
          } else {
            endPoint = "/biztalkCenterApi/alimtalk/template/create";
          }
          apiResponse = await ApiRequest.post(endPoint, templateBase);
          console.log("여기 : " + JSON.stringify(apiResponse));
        } catch (error) {
          console.log(error);
        }
      }

      console.log(apiResponse?.code);
      if (apiResponse?.code === "200" || messageTemplateType == "friendtalk") {
        const data = {
          channelName: selectedChannel.channelName,
          templateType: messageTemplateType,
          senderKey: selectedChannel.channelKey,
          templateCode: templateCode,
          templateName: templateName,
          templateContent: templateContent,
          templateMessageType: messageType,
          templateEmphasizeType: emphasisType,
          templateExtra: additionalInfo,
          templateImageName: selectedSingleImageData?.name,
          templateImageUrl: selectedSingleImageData?.imageUrl,
          templateHeader: templateBase.templateHeader,
          templateItemHighlight: templateBase.templateItemHighlight,
          templateItem: templateBase.templateItem,
          templateRepresentLink: templateBase.templateRepresentLink,
          categoryCode: templateBase.categoryCode,
          templateTitle: templateBase.templateTitle,
          templateSubtitle: templateBase.templateSubtitle,
          senderKeyType: templateBase.senderKeyType,
          securityFlag: templateBase.securityFlag,
          inspectionStatus: apiResponse?.data.inspectionStatus,
          status: apiResponse?.data.status,
          mmsAttach: JSON.stringify(mmsBase),
          buttons: JSON.stringify(buttons),
          quickReplies: JSON.stringify(templateBase.quickReplies),
          itemListHeader: itemListHeader,
          itemListTitle1: itemListTitle1,
          itemListTitle2: itemListTitle2,
          itemListTitle3: itemListTitle3,
          itemListTitle4: itemListTitle4,
          itemListTitle1Url: itemListTitle1Url,
          itemListTitle2Url: itemListTitle2Url,
          itemListTitle3Url: itemListTitle3Url,
          itemListTitle4Url: itemListTitle4Url,
          carouselHeader1: carouselFeeds[0]?.header,
          carouselHeader2: carouselFeeds[1]?.header,
          carouselHeader3: carouselFeeds[2]?.header,
          carouselHeader4: carouselFeeds[3]?.header,
          carouselHeader5: carouselFeeds[4]?.header,
          carouselHeader6: carouselFeeds[5]?.header,
          carouselMessage1: carouselFeeds[0]?.content,
          carouselMessage2: carouselFeeds[1]?.content,
          carouselMessage3: carouselFeeds[2]?.content,
          carouselMessage4: carouselFeeds[3]?.content,
          carouselMessage5: carouselFeeds[4]?.content,
          carouselMessage6: carouselFeeds[5]?.content,
        };

        let targetToSend = {
          tableName: "template",
          data: data,
          filter: {
            id: templateForEditMode.Id,
          },
        };

        console.log(targetToSend);
        console.log(selectedSingleImageData);
        console.log(templateBase);
        console.log(buttons);
        console.log(quickLinks);

        try {
          let endPoint;
          if (isTemplateEditMode) {
            endPoint = "/db/updateData";
          } else {
            endPoint = "/db/insertData";
          }
          const apiResponse = await ApiRequest.post(endPoint, targetToSend);
          console.log(apiResponse);
          closeNewTemplateDialog();
          getTemplates();
        } catch (error) {
          console.log(error);
        }
      } else {
        showAlert(apiResponse.message, "error", BASIC_ALERT_DURATION);
      }
    }
    setLoadingModal(false);
  };

  const validateUrl = (value) => {
    try {
      // '#{변수}' 형태가 포함된 경우 bypass
      const regex = /#\{.*?\}/g;
      if (regex.test(value)) {
        return true;
      } else {
        new URL(value);
        return true;
      }
    } catch (_) {
      return false;
    }
  };

  const handleTextSelect = (event, groupIndex, buttonIndex) => {
    const selectionStart = event.target?.selectionStart;
    const selectionEnd = event.target?.selectionEnd;
    const selectedText = event.target?.value.slice(selectionStart, selectionEnd);
    const field = event.target?.name;

    setSelectedText({ text: selectedText, field: field, groupIndex: groupIndex, buttonIndex: buttonIndex });
  };

  return (
    <>
      <Dialog maxWidth="lg" fullWidth open={newTemplateDialog} onClose={() => closeNewTemplateDialog()}>
        <DialogTitle>템플릿 생성</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "row",
          }}>
          {loadingModal ? (
            <Backdrop open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <></>
          )}
          <Grid container spacing={2} wrap="nowrap" style={{ position: "relative", minHeight: "1800px" }}>
            {/* 템플릿 입력 섹션 */}
            <Grid item xs={8} style={{ minHeight: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl error={errorCheck.selectedChannel} component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">채널</FormLabel>
                    <Select error={errorCheck.selectedChannel} value={selectedChannel} onChange={handleSelectedChannel} disabled={isTemplateReadOnlyMode || (isTemplateEditMode && !isTemplateReadOnlyMode)}>
                      {channels.map((channel, index) => (
                        <MenuItem key={index} value={channel}>
                          {channel.channelName}
                        </MenuItem>
                      ))}
                    </Select>
                    {errorCheck.selectedChannel && <FormHelperText>저장 시 채널은 필수로 선택해주세요.</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">템플릿 유형</FormLabel>
                    <RadioGroup row aria-label="templateType" name="templateType" value={messageTemplateType} onChange={handleMessageTemplateTypeChange}>
                      <FormControlLabel value="alimtalk" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="알림톡" />
                      <FormControlLabel value="friendtalk" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="친구톡" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl error={errorCheck.templateCode} component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">템플릿코드</FormLabel>
                    <TextField helperText={errorCheck.templateCode && "저장 시 템플릿코드는 필수로 입력해주세요."} error={errorCheck.templateCode} value={templateCode} onChange={(event) => setTemplateCode(event.target.value)} fullWidth margin="dense" variant="outlined" disabled={isTemplateReadOnlyMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl error={errorCheck.templateName} component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">템플릿명</FormLabel>
                    <TextField helperText={errorCheck.templateName && "저장 시 템플릿명은 필수로 입력해주세요."} error={errorCheck.templateName} value={templateName} onChange={(event) => setTemplateName(event.target.value)} fullWidth margin="dense" variant="outlined" disabled={isTemplateReadOnlyMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />
                  </FormControl>
                </Grid>
                <Divider />
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">메세지유형 </FormLabel>
                    <RadioGroup row aria-label="messageType" name="messageType" value={messageType} onChange={handleMessageTypeChange}>
                      {messageTemplateType === "alimtalk" && (
                        <>
                          <FormControlLabel value="BA" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="기본형" />
                          <FormControlLabel value="EX" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="부가정보형" />
                          <FormControlLabel value="AD" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="채널추가형" />
                          <FormControlLabel value="MI" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="복합형" />
                        </>
                      )}
                      {messageTemplateType === "friendtalk" && (
                        <>
                          <FormControlLabel value="text" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="텍스트형" />
                          <FormControlLabel value="image" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="이미지형" />
                          <FormControlLabel value="wide" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="와이드형" />
                          <FormControlLabel value="FL" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="와이드 아이템리스트형" />
                          <FormControlLabel value="FC" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="캐러셀 피드형" />
                          {messageType === "text" && (
                            <Box display="flex" alignItems="center">
                              <InfoIcon />
                              <Typography variant="body1">한/영 구분없이 띄어쓰기 포함 1,000자 텍스트 + 링크버튼 최대 5 (세로 배열)</Typography>
                            </Box>
                          )}
                          {messageType === "image" && (
                            <Box display="flex" alignItems="center">
                              <InfoIcon />
                              <Typography variant="body1">한/영 구분없이 띄어쓰기 포함 400자 텍스트 + 이미지 1장 + 링크버튼 최대 5 (세로 배열)</Typography>
                            </Box>
                          )}
                          {messageType === "wide" && (
                            <Box display="flex" alignItems="center">
                              <InfoIcon />
                              <Typography variant="body1">한/영 구분없이 띄어쓰기 포함 76자 텍스트 + 이미지 1장 + 링크버튼 1개</Typography>
                            </Box>
                          )}
                          {messageType === "FL" && (
                            <Box display="flex" alignItems="center">
                              <InfoIcon />
                              <Typography variant="body1">한/영 구분없이 띄어쓰기 포함 25자 텍스트 + 이미지 아이템 3~4개 + 링크버튼 최대 2개 (가로정렬)</Typography>
                            </Box>
                          )}
                          {messageType === "FC" && (
                            <Box display="flex" alignItems="center">
                              <InfoIcon />
                              <Typography variant="body1">한/영 구분없이 띄어쓰기 포함 '제목' 20자 텍스트 + '문구' 180자 텍스트 + '이미지 + 링크버튼 2개(가로정렬)'로 구성된 아이템 최대 6개</Typography>
                            </Box>
                          )}
                        </>
                      )}
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {messageTemplateType === "alimtalk" && (
                  <Grid item xs={12}>
                    <FormControl component="fieldset" margin="normal">
                      <FormLabel component="legend">강조유형 </FormLabel>
                      <RadioGroup row aria-label="emphasisType" name="emphasisType" value={emphasisType} onChange={handleEmphasisTypeChange}>
                        <FormControlLabel value="NONE" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="선택안함" />
                        <FormControlLabel value="TEXT" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="강조표기형" />
                        <FormControlLabel value="IMAGE" control={<Radio disabled={isTemplateReadOnlyMode || isCloneMode || (isTemplateEditMode && !isTemplateReadOnlyMode)} />} label="이미지형" />
                        <FormControlLabel value="ITEM_LIST" control={<Radio disabled />} label="아이템리스트형" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                )}
                <Divider />
                {(emphasisType === "IMAGE" || messageType === "image" || messageType === "wide" || messageType === "FL" || messageType === "FC") && (
                  <Grid item xs={12}>
                    <Button variant="outlined" color="primary" onClick={handleImageSelect} disabled={isTemplateReadOnlyMode}>
                      이미지 선택하기
                    </Button>
                  </Grid>
                )}
                {emphasisType === "TEXT" && (
                  <>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">강조표기 타이틀(최대 50자, 24자 입력 시 말줄임 처리) </FormLabel>
                        <TextField error={errorCheck.title} inputProps={{ maxLength: 50 }} value={title} onChange={(event) => setTitle(event.target.value)} margin="dense" variant="outlined" fullWidth disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">강조표기 보조문구(최대 50자, 24자 입력 시 말줄임 처리)</FormLabel>
                        <TextField error={errorCheck.subtitle} inputProps={{ maxLength: 50 }} value={subtitle} onChange={(event) => setSubtitle(event.target.value)} margin="dense" variant="outlined" fullWidth disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                  </>
                )}
                {(messageType === "EX" || messageType === "MI") && (
                  <Grid item xs={12}>
                    <FormControl component="fieldset" margin="normal" fullWidth>
                      <FormLabel component="legend">부가정보(최대 500자 입력) </FormLabel>
                      <TextField error={errorCheck.additionalInfo} inputProps={{ maxLength: 500 }} multiline fullWidth rows={4} value={additionalInfo} onChange={(e) => setAdditionalInfo(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                    </FormControl>
                  </Grid>
                )}
                {messageTemplateType === "alimtalk" && (
                  <Grid item xs={12}>
                    <Stack direction="row" spacing={1}>
                      <FormControlLabel control={<Checkbox checked={securityTemplate} onChange={handleSecurityTemplateChange} disabled={isTemplateReadOnlyMode} />} label="보안템플릿 설정" />
                      {/* <FormControlLabel control={<Checkbox checked={representativeLink} onChange={handleRepresentativeLinkChange} disabled={isTemplateReadOnlyMode} />} label="대표링크 사용" /> */}
                    </Stack>
                  </Grid>
                )}
                {/* 아이템리스트 입력 섹션 */}
                {messageType === "FL" && (
                  <>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 헤더(최대 25자 입력)</FormLabel>
                        <TextField error={errorCheck.itemListHeader} inputProps={{ maxLength: 25 }} fullWidth value={itemListHeader} onChange={(e) => setItemListHeader(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 1(최대 25자 입력)</FormLabel>
                        <TextField error={errorCheck.itemListTitle1} inputProps={{ maxLength: 25 }} fullWidth value={itemListTitle1} onChange={(e) => setItemListTitle1(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 1 URL</FormLabel>
                        <TextField error={errorCheck.itemListTitle1Url} fullWidth value={itemListTitle1Url} onChange={(e) => setItemListTitle1Url(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 2(최대 25자 입력)</FormLabel>
                        <TextField error={errorCheck.itemListTitle2} inputProps={{ maxLength: 25 }} fullWidth value={itemListTitle2} onChange={(e) => setItemListTitle2(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 2 URL</FormLabel>
                        <TextField error={errorCheck.itemListTitle2Url} fullWidth value={itemListTitle2Url} onChange={(e) => setItemListTitle2Url(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 3(최대 25자 입력)</FormLabel>
                        <TextField error={errorCheck.itemListTitle3} inputProps={{ maxLength: 25 }} fullWidth value={itemListTitle3} onChange={(e) => setItemListTitle3(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 3 URL</FormLabel>
                        <TextField error={errorCheck.itemListTitle3Url} fullWidth value={itemListTitle3Url} onChange={(e) => setItemListTitle3Url(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 4(최대 25자 입력)</FormLabel>
                        <TextField error={errorCheck.itemListTitle4} inputProps={{ maxLength: 25 }} fullWidth value={itemListTitle4} onChange={(e) => setItemListTitle4(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl component="fieldset" margin="normal" fullWidth>
                        <FormLabel component="legend">아이템 리스트 제목 4 URL</FormLabel>
                        <TextField error={errorCheck.itemListTitle4Url} fullWidth value={itemListTitle4Url} onChange={(e) => setItemListTitle4Url(e.target.value)} variant="outlined" disabled={isTemplateReadOnlyMode} />
                      </FormControl>
                    </Grid>
                  </>
                )}
                {/* 아이템리스트 입력 섹션 */}

                {messageType !== "FL" && messageType !== "FC" && (
                  <Grid item xs={12}>
                    <FormControl error={errorCheck.templateContent} component="fieldset" margin="normal" fullWidth>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <FormLabel component="legend">템플릿내용(최대 {getMaxLength()}자 입력)</FormLabel>
                        <Button variant="outlined" size="small" startIcon={<DataObjectIcon />} onClick={handleVariableButton} disabled={isTemplateReadOnlyMode}>
                          변수처리
                        </Button>
                      </Box>
                      <TextField error={errorCheck.templateContent} inputProps={{ maxLength: getMaxLength() }} value={templateContent} onChange={handleTemplateContentChange} margin="dense" variant="outlined" fullWidth multiline rows={6} placeholder="템플릿 내용을 입력해주세요." disabled={isTemplateReadOnlyMode} />
                    </FormControl>
                  </Grid>
                )}

                {/* 템플릿내용 입력 섹션 */}
                {carouselFeeds.map((carouselFeed, index) => (
                  <>
                    {/*캐러샐피드형*/}
                    {messageType === "FC" && (
                      <>
                        <Grid item xs={12}>
                          <FormControl component="fieldset" margin="normal" fullWidth>
                            <Box key={index}>
                              <FormLabel component="legend">
                                템플릿 헤더 {index + 1} (최대 {getMaxLength().header}자 입력)
                              </FormLabel>
                              <TextField inputProps={{ maxLength: getMaxLength().header }} value={carouselFeed.header} onChange={(event) => handleCarouselFeedChange(index, "header", event.target.value)} margin="dense" variant="outlined" fullWidth multiline rows={6} placeholder="템플릿 헤더를 입력해주세요." disabled={isTemplateReadOnlyMode} />
                            </Box>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl component="fieldset" margin="normal" fullWidth>
                            <Box key={index}>
                              <FormLabel component="legend">
                                템플릿내용 {index + 1} (최대 {getMaxLength().content}자 입력)
                              </FormLabel>
                              <TextField inputProps={{ maxLength: getMaxLength().content }} value={carouselFeed.content} onChange={(event) => handleCarouselFeedChange(index, "content", event.target.value)} margin="dense" variant="outlined" fullWidth multiline rows={6} placeholder="템플릿 내용을 입력해주세요." disabled={isTemplateReadOnlyMode} />
                            </Box>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    {/* 템플릿내용 입력 섹션 */}
                    {/* 버튼 섹션 */}
                    <Grid item xs={12}>
                      {/*캐러샐피드형*/}

                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                          {messageType === "FC" ? `버튼 ${index + 1}` : "버튼"}
                          <IconButton color="primary" onClick={() => handleAddButton(index)} disabled={isTemplateReadOnlyMode}>
                            <AddCircleOutlineIcon />
                          </IconButton>
                        </Box>
                        {messageTemplateType !== "alimtalk" && (
                          <Button variant="outlined" size="small" startIcon={<DataObjectIcon />} onClick={handleButtonLinkVariableButton} disabled={isTemplateReadOnlyMode}>
                            링크변수처리
                          </Button>
                        )}
                      </Box>

                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>유형</TableCell>
                            <TableCell>이름</TableCell>
                            <TableCell>링크</TableCell>
                            <TableCell>삭제</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {buttons[index]?.length === 0 && !isTemplateReadOnlyMode ? (
                            <TableRow>
                              <TableCell align="center" colSpan="4">
                                상단 + 버튼을 클릭하여 추가
                              </TableCell>
                            </TableRow>
                          ) : (
                            <>
                              {buttons[index]?.map((button, buttonIndex) => (
                                <TableRow key={buttonIndex}>
                                  <TableCell>
                                    <Select size="small" disabled={button.readOnly || isTemplateReadOnlyMode} fullWidth value={button.linkType} onChange={(e) => handleButtonTypeChange(index, buttonIndex, e)}>
                                      <MenuItem value="NONE">선택하기</MenuItem>
                                      <MenuItem value="WL">웹링크</MenuItem>
                                      <MenuItem value="AL">앱링크</MenuItem>
                                      <MenuItem value="BK">봇키워드</MenuItem>
                                      <MenuItem value="MD">메시지전달</MenuItem>
                                      {buttonIndex === 0 && (messageType === "AD" || messageType === "MI") ? <MenuItem value="AC">채널추가</MenuItem> : ""}
                                    </Select>
                                  </TableCell>
                                  <TableCell>
                                    <TextField size="small" disabled={button.readOnly || isTemplateReadOnlyMode} fullWidth value={button.name} onChange={(event) => handleButtonNameChange(index, buttonIndex, event)} inputProps={{ maxLength: 14 }} />
                                  </TableCell>
                                  <TableCell>
                                    <Stack spacing={2} direction="column">
                                      {button.linkType === "AL" && (
                                        <>
                                          <TextField
                                            name="linkAnd"
                                            onSelect={(event) => handleTextSelect(event, index, buttonIndex)}
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(button.linkAnd) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(button.linkAnd)}
                                            value={button.linkAnd}
                                            onChange={(event) => handleButtonLinkChange(index, buttonIndex, "linkAnd", event.target.value)}
                                            fullWidth
                                            label="Android"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <AndroidIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                          <TextField
                                            name="linkIos"
                                            onSelect={(event) => handleTextSelect(event, index, buttonIndex)}
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(button.linkIos) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(button.linkIos)}
                                            value={button.linkIos}
                                            onChange={(event) => handleButtonLinkChange(index, buttonIndex, "linkIos", event.target.value)}
                                            fullWidth
                                            label="iOS"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <AppleIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                        </>
                                      )}

                                      {(button.linkType === "WL" || button.linkType === "AL") && (
                                        <>
                                          <TextField
                                            name="linkPc"
                                            onSelect={(event) => handleTextSelect(event, index, buttonIndex)}
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(button.linkPc) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(button.linkPc)}
                                            value={button.linkPc}
                                            onChange={(event) => handleButtonLinkChange(index, buttonIndex, "linkPc", event.target.value)}
                                            fullWidth
                                            label="PC"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <DesktopWindowsIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                          <TextField
                                            name="linkMo"
                                            onSelect={(event) => handleTextSelect(event, index, buttonIndex)}
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(button.linkMo) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(button.linkMo)}
                                            value={button.linkMo}
                                            onChange={(event) => handleButtonLinkChange(index, buttonIndex, "linkMo", event.target.value)}
                                            fullWidth
                                            label="Mobile"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <MobileFriendlyIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                        </>
                                      )}
                                    </Stack>
                                  </TableCell>
                                  <TableCell>
                                    {!button.readOnly && isTemplateReadOnlyMode === false && (
                                      <IconButton onClick={() => handleRemoveButton(index, buttonIndex)}>
                                        <DeleteIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </Grid>
                    {/*캐러샐피드형*/}
                    {messageType === "FC" && index >= 2 && (
                      <Button onClick={() => handleRemoveCarouselFeed(index)} disabled={isTemplateReadOnlyMode}>
                        템플릿 제거
                      </Button>
                    )}
                  </>
                ))}
                {/*캐러샐피드형*/}
                {messageType === "FC" && carouselFeeds.length < 6 && (
                  <Button onClick={handleAddCarouselFeed} disabled={isTemplateReadOnlyMode}>
                    템플릿 추가
                  </Button>
                )}
                {/* 바로가기 버튼 섹션 */}
                {messageTemplateType === "alimtalk" && (
                  <>
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                          바로가기
                          <IconButton color="primary" onClick={handleAddQuickLink} disabled={isTemplateReadOnlyMode}>
                            <AddCircleOutlineIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>유형</TableCell>
                            <TableCell>이름</TableCell>
                            <TableCell>링크</TableCell>
                            <TableCell>삭제</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {quickLinks?.length === 0 && !isTemplateReadOnlyMode ? (
                            <TableRow>
                              <TableCell align="center" colSpan="4">
                                상단 + 버튼을 클릭하여 추가
                              </TableCell>
                            </TableRow>
                          ) : (
                            <>
                              {quickLinks?.map((quickLink, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    <Select size="small" fullWidth value={quickLink.linkType} onChange={(e) => handleQuickLinkTypeChange(e, index)} disabled={isTemplateReadOnlyMode}>
                                      <MenuItem value="NONE">선택하기</MenuItem>
                                      <MenuItem value="WL">웹링크</MenuItem>
                                      <MenuItem value="AL">앱링크</MenuItem>
                                      <MenuItem value="BK">봇키워드</MenuItem>
                                      <MenuItem value="MD">메시지전달</MenuItem>
                                    </Select>
                                  </TableCell>
                                  <TableCell>
                                    <TextField size="small" fullWidth value={quickLink.name} onChange={(event) => handleQuickLinkNameChange(index, event)} inputProps={{ maxLength: 14 }} disabled={isTemplateReadOnlyMode} />
                                  </TableCell>
                                  <TableCell>
                                    <Stack spacing={2} direction="column">
                                      {quickLink.linkType === "AL" && (
                                        <>
                                          <TextField
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(quickLink.linkAnd) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(quickLink.linkAnd)}
                                            fullWidth
                                            value={quickLink.linkAnd}
                                            onChange={(event) => handleQuickLinkLinkChange(quickLink, index, "linkAnd", event.target.value)}
                                            size="small"
                                            label="Android"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <AndroidIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                          <TextField
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(quickLink.linkIos) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(quickLink.linkIos)}
                                            fullWidth
                                            value={quickLink.linkIos}
                                            onChange={(event) => handleQuickLinkLinkChange(quickLink, index, "linkIos", event.target.value)}
                                            size="small"
                                            label="iOS"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <AppleIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                        </>
                                      )}

                                      {(quickLink.linkType === "WL" || quickLink.linkType === "AL") && (
                                        <>
                                          <TextField
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(quickLink.linkPc) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(quickLink.linkPc)}
                                            fullWidth
                                            value={quickLink.linkPc}
                                            onChange={(event) => handleQuickLinkLinkChange(quickLink, index, "linkPc", event.target.value)}
                                            size="small"
                                            label="PC"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <DesktopWindowsIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                          <TextField
                                            disabled={isTemplateReadOnlyMode}
                                            helperText={!validateUrl(quickLink.linkMo) && "http:// 또는 https:// 로 시작하는 URL을 입력하세요."}
                                            error={!validateUrl(quickLink.linkMo)}
                                            fullWidth
                                            value={quickLink.linkMo}
                                            onChange={(event) => handleQuickLinkLinkChange(quickLink, index, "linkMo", event.target.value)}
                                            size="small"
                                            label="Mobile"
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <MobileFriendlyIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                            variant="standard"
                                          />
                                        </>
                                      )}
                                    </Stack>
                                  </TableCell>
                                  <TableCell>
                                    <IconButton onClick={() => handleRemoveQuickLink(index)} disabled={isTemplateReadOnlyMode}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">전송 실패 시 MMS 발송제목 </FormLabel>
                    <TextField value={failbackContentTitle} onChange={handlefailbackContentTitleChange} margin="dense" variant="outlined" fullWidth placeholder="카카오톡 전송 실패 시 전송할 문자메세지의 제목을 입력하세요." disabled={isTemplateReadOnlyMode} />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <FormLabel component="legend">전송 실패 시 MMS 발송내용 </FormLabel>
                    <TextField value={failbackContent} onChange={handlefailbackContentChange} margin="dense" variant="outlined" fullWidth multiline rows={6} placeholder="카카오톡 전송 실패 시 전송할 문자메세지를 입력하세요." disabled={isTemplateReadOnlyMode} />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Box width={5} /> {/* 여백 조절 */}
            </Grid>
            <Grid item xs={4} style={{ minHeight: "100%" }}>
              {/* 오른쪽 미리보기 화면 */}
              <FormControl style={{ position: "sticky", top: 10 }} component="fieldset" margin="normal" fullWidth>
                <FormLabel component="legend">미리보기 </FormLabel>
                <Paper
                  variant="outlined"
                  style={{
                    marginTop: "8px",
                    width: "100%",
                    height: "650px",
                    overflowY: "auto",
                    backgroundColor: "#c8d1dd",
                  }}>
                  <Stack direction="row" spacing={2} alignItems="center" sx={{ margin: "10px" }}>
                    <Avatar sx={{ bgcolor: "#c00032", borderRadius: "8px", width: "24px", height: "24px", fontSize: "13px" }}>LG</Avatar>
                    <Typography align="center" variant="subtitle1" color="text.secondary">
                      {selectedChannel?.channelName}
                    </Typography>
                  </Stack>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "left", marginLeft: "20px", marginRight: "20px" }}>
                    <Card sx={{ maxWidth: 500 }}>
                      {/*캐러샐피드형*/}
                      {messageType === "FC" ? (
                        <StyledCarousel swipeable={true} showThumbs={false} dynamicHeight={false} showStatus={false}>
                          {carouselFeeds.map((carouselFeed, index) => (
                            <>
                              <CardMedia component="img" height="auto" image={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[index]} />
                              <Stack direction="column" spacing={1} key={index}>
                                <Typography variant="subtitle1" fontWeight="bold" sx={{ margin: "10px !important", textAlign: "left" }}>
                                  {carouselFeed.header}
                                </Typography>
                                <Divider sx={{ marginLeft: "15px", marginRight: "15px" }} />
                                <Typography variant="body2" sx={{ textAlign: "left", margin: "10px !important" }}>
                                  {carouselFeed.content}
                                </Typography>
                                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ margin: "8px !important", justifyContent: "center" }}>
                                  {buttons[index]?.slice(0, 2).map((button, buttonIndex) => (
                                    <Button
                                      key={buttonIndex}
                                      variant="contained"
                                      fullWidth
                                      sx={{
                                        backgroundColor: "#6c757d",
                                        "&:hover": {
                                          backgroundColor: "#343a40",
                                        },
                                      }}>
                                      {button.name}
                                    </Button>
                                  ))}
                                </Stack>
                              </Stack>
                            </>
                          ))}
                        </StyledCarousel>
                      ) : messageType === "FL" ? (
                        <>
                          <Typography variant="body1" sx={{ fontWeight: "bold", margin: "10px", textAlign: "center" }}>
                            {itemListHeader}
                          </Typography>
                          <Box sx={{ position: "relative", maxWidth: 300, height: 120, margin: "auto", display: "block" }}>
                            <CardMedia component="img" sx={{ width: "100%", height: "100%" }} image={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[0]} />
                            <Typography variant="body2" sx={{ position: "absolute", bottom: 0, left: 0, color: "white", padding: "2px", textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
                              {itemListTitle1}
                            </Typography>
                          </Box>

                          <Stack direction="column" spacing={1}>
                            <Grid container spacing={1}></Grid>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={2}>
                                <CardMedia component="img" height="60" image={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[1]} />
                              </Grid>
                              <Grid item xs={10}>
                                <Typography variant="body2">{itemListTitle2}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={2}>
                                <CardMedia component="img" height="60" image={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[2]} />
                              </Grid>
                              <Grid item xs={10}>
                                <Typography variant="body2">{itemListTitle3}</Typography>
                              </Grid>
                            </Grid>
                            {itemListTitle4 && (
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={2}>
                                  <CardMedia component="img" height="60" image={selectedSingleImageData?.imageUrl && JSON.parse(selectedSingleImageData?.imageUrl)[3]} />
                                </Grid>
                                <Grid item xs={10}>
                                  <Typography variant="body2">{itemListTitle4}</Typography>
                                </Grid>
                              </Grid>
                            )}
                          </Stack>
                        </>
                      ) : (
                        <>
                          {(emphasisType === "IMAGE" || messageType === "image" || messageType === "wide") && selectedSingleImageData?.imageUrl && <CardMedia component="img" height="auto" image={JSON.parse(selectedSingleImageData?.imageUrl)[0]} />}
                          <CardContent>
                            {emphasisType === "TEXT" && (
                              <>
                                <Typography sx={{ textAlign: "left", color: "text.secondary" }} variant="body2">
                                  {subtitle}
                                </Typography>
                                <Typography sx={{ textAlign: "left", fontWeight: "bold" }} variant="h6">
                                  {title}
                                </Typography>
                                <Divider sx={{ marginLeft: "8px", marginRight: "8px", marginBottom: "10px", marginTop: "10px" }} />
                              </>
                            )}
                            <Typography sx={{ textAlign: "left", fontSize: "13px", wordWrap: "break-word", whiteSpace: "pre-wrap" }} variant="body2" color="text.primary" component="pre">
                              {templateContent}
                            </Typography>
                            {(messageType === "EX" || messageType === "MI") && (
                              <Typography
                                sx={{
                                  textAlign: "left",
                                  marginTop: "10px",
                                  fontSize: "12px",
                                  wordWrap: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                                variant="body2"
                                color="text.secondary">
                                {additionalInfo}
                              </Typography>
                            )}
                          </CardContent>
                        </>
                      )}

                      {messageType !== "FC" && (
                        <Stack spacing={0.5} sx={{ margin: "10px" }}>
                          {(messageType === "AD" || messageType === "MI") && (
                            <Typography sx={{ textAlign: "left", marginBottom: "5px" }} variant="body2" color="text.secondary">
                              채널 추가하고 이 채널의 광고와 마케팅 메시지를 카카오톡으로 받기
                            </Typography>
                          )}

                          {messageType === "FL" ? (
                            <Stack direction="row" spacing={0.5} alignItems="center">
                              {buttons.map((buttonSet, buttonSetIndex) =>
                                buttonSet.map((button, buttonIndex) => (
                                  <Button
                                    key={buttonIndex}
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                      backgroundColor: "#6c757d",
                                      "&:hover": {
                                        backgroundColor: "#343a40",
                                      },
                                    }}>
                                    {button.name}
                                  </Button>
                                ))
                              )}
                            </Stack>
                          ) : (
                            buttons[0]?.map((button, index) => (
                              <Button
                                key={index}
                                variant="contained"
                                fullWidth
                                sx={{
                                  backgroundColor: "#6c757d",
                                  "&:hover": {
                                    backgroundColor: "#343a40",
                                  },
                                }}>
                                {button.name}
                              </Button>
                            ))
                          )}
                        </Stack>
                      )}
                    </Card>
                    <Box sx={{ maxWidth: 500, display: "flex", flexWrap: "nowrap", marginTop: "10px" }}>
                      <Stack spacing={0.5} sx={{ marginTop: "10px" }} direction="row">
                        {quickLinks?.map((quickLink, index) => (
                          <Chip
                            label={quickLink.name}
                            key={index}
                            sx={{
                              backgroundColor: "#ffffff",
                              color: "#000000",
                              whiteSpace: "nowrap",
                              minWidth: "0",
                              "&:hover": {
                                backgroundColor: "#f1f1f1",
                              },
                            }}></Chip>
                        ))}
                      </Stack>
                    </Box>
                  </Box>
                </Paper>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCreateTemplate} variant="contained" color="primary">
            저장
          </Button>
          <Button variant="contained" color="primary" onClick={() => closeNewTemplateDialog()}>
            취소
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewTemplateDialog;
